/* eslint-disable import/prefer-default-export */
export const deleteUser = `mutation deleteUser {
    deleteUser
}
`
